import * as React from "react";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";

const OPTIONS = [
  { key: "owner", label: "Ägare" },
  { key: "status", label: "Status" },
  { key: "due", label: "Förfallodatum" },
  { key: "notes", label: "Anteckningar" },
  { key: "files", label: "Filer" },
  { key: "priority", label: "Prioritet" },
  { key: "updated", label: "Senast uppdaterat" },
  { key: "timeline", label: "Tidslinje" },
  { key: "budget", label: "Budget" },
];

export default function StepChooseColumns({
  value = [],
  onNext,
  onBack,
  showActions = true,
}) {
  const initial = value.length ? value : ["owner", "status", "due"];
  const [picked, setPicked] = React.useState(new Set(initial));

  // Håll parent synkad så globala "Nästa" kan validera
  React.useEffect(() => {
    if (onNext) onNext({ columns: Array.from(picked) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [picked]);

  // Synka om parent byter value externt
  React.useEffect(() => {
    setPicked(new Set(initial));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value?.join("|")]);

  const toggle = (k) =>
    setPicked((p) => new Set(p.has(k) ? [...p].filter((x) => x !== k) : [...p, k]));

  const submit = () => onNext?.({ columns: Array.from(picked) });

  return (
    <Stack spacing={3} sx={{ p: 2 }}>
      <Box>
        <Typography variant="h4" fontWeight={800} gutterBottom>
          Välj kolumner
        </Typography>
      </Box>

      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
        {OPTIONS.map(({ key, label }) => {
          const checked = picked.has(key);
          return (
            <Chip
              key={key}
              onClick={() => toggle(key)}
              color={checked ? "primary" : "default"}
              variant={checked ? "filled" : "outlined"}
              label={label}
              sx={{ px: 1.25, py: 0.5, borderRadius: 3 }}
            />
          );
        })}
      </Stack>

      {showActions && (
        <Stack direction="row" spacing={2}>
          <Button onClick={onBack}>Tillbaka</Button>
          <Button variant="contained" onClick={submit}>
            Nästa
          </Button>
        </Stack>
      )}
    </Stack>
  );
}
